var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 px-sm-10"},[_c('div',{staticClass:"text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"},[_vm._v(" Сессии ")]),_c('v-card',{staticClass:"pa-5"},[_c('object-grid',{attrs:{"content_type":'products',"value":_vm.visit || [],"show-actions":{
        edit: true,
      },"field-defs":[
        { text: 'Сессия', value: 'product_name' },
        { text: 'Дата', value: 'date' },
      ]},on:{"doEditItem":_vm.showSessionDialog}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }